/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface ICardDefinition{
    id:number,
    name:string,
    remark:string,
    effectiveDay:number,
    sellPrice:string,
    enable:boolean,
    courseMessage:string,
    courseDefinitionRefs:ICardDefinitionCourseDefinitionRef[]
}

export interface ICardDefinitionCourseDefinitionRef{
    id:number,
    value:number,
    cardDefinitionId:number,
    courseDefinitionId:number,
    courseDefinitionName:string,
    courseDefinitionRemark:string,
}

export const listCardDefinitions = () =>
    getCommon({
        url: `${config.SERVICE_URL}/card_definition/list_all`,
    });

export const createCardDefinition = (data:ICardDefinition) =>
    postCommon({
        url: `${config.SERVICE_URL}/card_definition/create`,
        data
    });

export const updateCardDefinition = (data:ICardDefinition) =>
    postCommon({
        url: `${config.SERVICE_URL}/card_definition/update`,
        data
    });

export const deleteCardDefinition = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/card_definition/delete?id=${id}`
    });

export const enableCardDefinition = (id:number, enable:boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/card_definition/enable?id=${id}&&enable=${enable}`
    });

export const pageCardDefinitions = (pageNum:number,pageSize:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/card_definition/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });